import React, { useEffect, useState } from "react";
import { Clock, Flame } from "lucide-react";

// Evergreen daily countdown — resets every day at midnight IST.
export default function DealCountdown({ testId = "deal-countdown" }) {
  const [remaining, setRemaining] = useState({ h: 0, m: 0, s: 0 });

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const end = new Date(now);
      end.setHours(23, 59, 59, 999);
      const diff = Math.max(0, end - now);
      setRemaining({
        h: Math.floor(diff / 3600000),
        m: Math.floor((diff % 3600000) / 60000),
        s: Math.floor((diff % 60000) / 1000),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div
      className="bg-[#e63946] text-white px-6 py-3 flex items-center gap-4 flex-wrap"
      data-testid={testId}
    >
      <div className="flex items-center gap-2">
        <Flame size={16} className="animate-pulse" />
        <span className="font-display uppercase text-sm md:text-base tracking-tight">
          Deal of the day
        </span>
      </div>
      <div className="flex-1 min-w-[140px] font-mono text-xs md:text-sm uppercase tracking-[0.15em]">
        Special WhatsApp pricing ends in
      </div>
      <div className="flex items-center gap-2 font-mono font-bold" data-testid="countdown-clock">
        <Clock size={14} />
        <span className="text-lg tabular-nums">
          {pad(remaining.h)}:{pad(remaining.m)}:{pad(remaining.s)}
        </span>
      </div>
    </div>
  );
}
